export default __webpack_public_path__ + "static/media/ico_bonusCheckbox_disabled.4007f3d5.svg";